import { Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  container: {
    //paddingX: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    height: "100%",
  },
  paper: {
    padding: 2,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
  },
  boxHeader: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    height: "fit-content",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "end", //{ xs: "start", md: "center" },
    gap: 2,
  },
  boxSearchAndFilter: {
    display: "flex",
    flexDirection: "column", // { xs: "column", md: "row" },
    width: "100%",
    gap: 2,
  },
  button: {
    height: "40px",
    transition: "opacity 0.5s, background-color 0.5s, filter 0.5s, color 0.5s",
    opacity: 1,
  },
  searchInput: {
    width: { xs: "100%", md: "400px" },
  },
  dataGrid: {
    width: "100%",
    height: "100%",
    minHeight: 500,
    fontSize: 12,
    borderRadius: 0,
    border: 0,
    backgroundColor: "transparent",
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-visible": {
      outline: `2px solid ${theme.palette.primary.main} !important`,
      outlineOffset: "-2px",
    },
    ".MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      borderColor: theme.palette.stroke,
    },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--borderTop": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--header": {
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.stroke}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "text.primary", // Altera a cor do titulo do cabeçalho
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent", // Altera cor do rodapé
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      height: "45px",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: theme.palette.background.paper, // Altera cor do cabeçalho
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      width: "100%",
    },
    "& .MuiDataGrid-topContainer": {
      border: 0,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row--borderBottom": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      border: 0,
      height: "55px",
      backgroundColor: theme.palette.background.paper,
    },

    "& .even-row": { backgroundColor: theme.palette.table },
    "& .odd-row": { backgroundColor: theme.palette.background.paper },
  },

  boxRenderCell: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    alignItems: "center",
    gap: 1,
  },
  typography: {
    fontSize: "0.8rem",
  },
  boxButton: { display: "flex", gap: 1, width: "100%", justifyContent: "end" },
  chip: {
    borderRadius: "8px",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.cardProfile,
    padding: "0px 8px",
    height: "28px",
    maxWidth: "100px",
    marginRight: "4px",
    "& .MuiChip-label": {
      padding: 0,
    },
  },
  boxNoRowsOverlay: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    height: "100%",
  },
  iconUserNotFound: {
    width: "140px",
    height: "140px",
    fill: theme.palette.text.disabled,
  },
  containerColumnLastLogin: {
    display: "flex",
    justifyContent: "start",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 0.5,
    height: "100%",
  },
  textDate: {
    color: "text.primary",
    // fontWeight: 400,
    lineHeight: 1.5,
  },
  subTextDate: {
    color: "text.primary",
    fontWeight: 400,
    lineHeight: 1.5,
  },
});
